<template>

<div class="_page">
  <DemoBody>
    <DemoBodyResult
      :resultTitle="'Base Tags'"
      :extra="true"
      :extraTitle="'Color Dominant'"
      :imageUrl="imageUrl"
      :sampleImages="sampleImages"
      v-on:reset="$emit('reset')"
      v-on:setSampleImage="$emit('setSampleImage', $event)"
    >
      <template v-slot:resultBody>
        <Tags :empty="result?.base_tags?.length < 1">
          <TagItem 
            v-for="tag, i in result.base_tags" 
            :key="i" :label="tag.tag" :extra="`${parseInt(tag.confidence * 100)}%`"
          />
        </Tags>
      </template>
      <template v-slot:extraBody>
        <ColorDominance :colors="result.color_dominant"/>
      </template>


    </DemoBodyResult>
  </DemoBody>
</div>

</template>

<script>
import DemoResultView from '../DemoResultView'
import ColorDominance from '@/components/colors/ColorDominance'

export default {
  extends: DemoResultView,
  components: {
    ColorDominance,
  }
}

</script>